<div [class.full-screen]="isFullScreen" class="loading-container">
    <ng-lottie [options]="selectedAnimation" width="250px" height="250px"></ng-lottie>
    <p *ngIf="displayMessage.length > 0" class="loading-text">{{ displayMessage }}</p>
</div>